// Dados de exemplo (mock) do catálogo da Casa Flor.
// Usados apenas enquanto o backend real não está conectado.
// Ao conectar o Readdy Backend / Supabase, substituir por dados reais e apagar este arquivo.

export const mockCategories = [
  { id: 1, name: "Vasos & Plantas", sort_order: 1 },
  { id: 2, name: "Cerâmica & Louças", sort_order: 2 },
  { id: 3, name: "Almofadas & Têxteis", sort_order: 3 },
  { id: 4, name: "Velas & Aromas", sort_order: 4 },
  { id: 5, name: "Iluminação", sort_order: 5 },
  { id: 6, name: "Objetos Decorativos", sort_order: 6 },
];

export const mockProducts = [
  {
    id: 1,
    name: "Vaso de Cerâmica Terracota \"Chão de Barro\"",
    category_id: 1,
    status: "active",
    description:
      "Vaso de cerâmica artesanal modelado à mão, com acabamento em tom de terracota natural. Cada peça tem textura e marcas próprias, o que torna cada vaso único. Ideal para plantas de médio porte e arranjos secos.",
    pricing_mode: 1,
    currency: "BRL",
    price: 129.9,
    stock: 14,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Terracotta%20ceramic%20vase%20handmade%20with%20natural%20earthy%20texture%20and%20subtle%20ribbed%20lines%2C%20standing%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20daylight%20from%20the%20side%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20muted%20warm%20tones%2C%20shallow%20depth%20of%20field%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p1a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Terracotta%20ceramic%20vase%20with%20a%20small%20green%20plant%20pothos%20leaves%2C%20placed%20on%20a%20light%20wooden%20shelf%20against%20a%20warm%20cream%20wall%2C%20soft%20natural%20window%20light%2C%20cozy%20Brazilian%20interior%20decoration%20scene%2C%20earthy%20neutral%20palette%2C%20realistic%20lifestyle%20product%20photography&width=800&height=800&seq=casaflor-p1b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 1, name: "Vasos & Plantas", sort_order: 1 },
  },
  {
    id: 2,
    name: "Cesto de Palha Trançada \"Sertão\"",
    category_id: 1,
    status: "active",
    description:
      "Cesto trançado à mão em palha natural, feito por artesãs do interior. Versátil: serve como cachepô, organizador ou peça decorativa. Traz textura e aconchego para qualquer cantinho da casa.",
    pricing_mode: 1,
    currency: "BRL",
    price: 89.9,
    stock: 22,
    discount_enabled: true,
    discount_price: 74.9,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Handwoven%20natural%20straw%20basket%20with%20visible%20braided%20texture%20and%20a%20rounded%20shape%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20store%2C%20earthy%20beige%20and%20sand%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p2a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Handwoven%20straw%20basket%20holding%20a%20potted%20green%20plant%20on%20a%20wooden%20floor%20beside%20a%20linen%20curtain%2C%20warm%20morning%20sunlight%2C%20cozy%20Brazilian%20living%20room%20corner%2C%20natural%20earthy%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p2b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 1, name: "Vasos & Plantas", sort_order: 1 },
  },
  {
    id: 3,
    name: "Conjunto de Louças \"Mesa Posta\"",
    category_id: 2,
    status: "active",
    description:
      "Conjunto de louças de cerâmica com acabamento fosco e esmalte em tom de argila. Peças levemente irregulares, feitas em forno artesanal. Perfeito para deixar a mesa posta com personalidade.",
    pricing_mode: 1,
    currency: "BRL",
    price: 249.9,
    stock: 8,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Set%20of%20handmade%20ceramic%20dinnerware%20plates%20bowls%20and%20mugs%20in%20matte%20clay%20glaze%2C%20arranged%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20earthy%20terracotta%20and%20sand%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p3a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Set%20table%20with%20handmade%20ceramic%20plates%20bowls%20and%20cups%20over%20a%20linen%20tablecloth%20with%20dried%20flowers%2C%20warm%20afternoon%20sunlight%2C%20cozy%20Brazilian%20dining%20scene%2C%20earthy%20neutral%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p3b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 2, name: "Cerâmica & Louças", sort_order: 2 },
  },
  {
    id: 4,
    name: "Tigela de Barro Pintada à Mão",
    category_id: 2,
    status: "active",
    description:
      "Tigela utilitária de barro, pintada à mão com desenhos orgânicos em tons de terra. Resistente e segura para alimentos. Cada peça sai do forno com um traço exclusivo.",
    pricing_mode: 1,
    currency: "BRL",
    price: 79.9,
    stock: 30,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Handmade%20clay%20bowl%20with%20hand%20painted%20organic%20line%20pattern%20in%20earthy%20brown%20and%20cream%20tones%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20rustic%20ceramic%20texture%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p4a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Handmade%20clay%20bowl%20filled%20with%20fresh%20fruit%20on%20a%20wooden%20kitchen%20counter%2C%20soft%20morning%20light%2C%20cozy%20Brazilian%20home%20scene%2C%20earthy%20warm%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p4b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 2, name: "Cerâmica & Louças", sort_order: 2 },
  },
  {
    id: 5,
    name: "Almofada de Linho \"Terra\"",
    category_id: 3,
    status: "active",
    description:
      "Almofada de linho lavado com enchimento macio e zíper invisível. Tecido natural, respirável e com caimento leve. Disponível em cores que combinam com qualquer ambiente.",
    pricing_mode: 1,
    currency: "BRL",
    price: 149.9,
    stock: 18,
    discount_enabled: true,
    discount_price: 119.9,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Linen%20throw%20pillow%20cushion%20in%20warm%20terracotta%20color%20with%20soft%20natural%20fabric%20texture%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20cozy%20earthy%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p5a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Linen%20cushions%20in%20terracotta%20sage%20and%20sand%20tones%20arranged%20on%20a%20light%20sofa%20with%20a%20knitted%20blanket%2C%20warm%20afternoon%20sunlight%2C%20cozy%20Brazilian%20living%20room%2C%20natural%20earthy%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p5b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 3, name: "Almofadas & Têxteis", sort_order: 3 },
  },
  {
    id: 6,
    name: "Manta de Algodão Cru \"Aconchego\"",
    category_id: 3,
    status: "active",
    description:
      "Manta de algodão cru com trama aberta e acabamento em franjas. Leve e quente na medida certa, ideal para o sofá ou para os dias mais frescos. Fibra 100% natural.",
    pricing_mode: 1,
    currency: "BRL",
    price: 189.9,
    stock: 12,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Natural%20raw%20cotton%20throw%20blanket%20with%20open%20weave%20and%20soft%20fringe%20edges%2C%20folded%20neatly%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20cozy%20neutral%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p6a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Raw%20cotton%20blanket%20draped%20over%20an%20armchair%20in%20a%20cozy%20Brazilian%20reading%20corner%20with%20a%20wooden%20side%20table%20and%20plant%2C%20warm%20afternoon%20sunlight%2C%20natural%20earthy%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p6b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 3, name: "Almofadas & Têxteis", sort_order: 3 },
  },
  {
    id: 7,
    name: "Vela Aromática \"Cerrado\"",
    category_id: 4,
    status: "active",
    description:
      "Vela artesanal de cera vegetal com essência inspirada no cerrado brasileiro: notas verdes, levemente amadeiradas. Queima limpa e uniforme, em pote de vidro reutilizável.",
    pricing_mode: 1,
    currency: "BRL",
    price: 59.9,
    stock: 40,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Hand%20poured%20soy%20wax%20candle%20in%20an%20amber%20glass%20jar%20with%20a%20kraft%20label%20and%20wooden%20lid%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20warm%20earthy%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p7a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Amber%20glass%20candle%20lit%20on%20a%20bedside%20table%20with%20dried%20flowers%20and%20a%20linen%20cloth%2C%20soft%20warm%20evening%20glow%2C%20cozy%20Brazilian%20bedroom%20scene%2C%20earthy%20natural%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p7b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 4, name: "Velas & Aromas", sort_order: 4 },
  },
  {
    id: 8,
    name: "Difusor de Ambientes \"Flores do Campo\"",
    category_id: 4,
    status: "active",
    description:
      "Difusor de varetas com essência floral suave, feita com óleos essenciais. Perfuma o ambiente de forma contínua e discreta, sem chama. Frascos de vidro fosco.",
    pricing_mode: 1,
    currency: "BRL",
    price: 99.9,
    stock: 16,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Reed%20diffuser%20in%20a%20frosted%20glass%20bottle%20with%20natural%20rattan%20sticks%20and%20a%20subtle%20label%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20fresh%20earthy%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p8a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Reed%20diffuser%20bottle%20on%20a%20bathroom%20shelf%20with%20a%20small%20plant%20and%20folded%20white%20towels%2C%20soft%20morning%20light%2C%20calm%20Brazilian%20home%20scene%2C%20natural%20neutral%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p8b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 4, name: "Velas & Aromas", sort_order: 4 },
  },
  {
    id: 9,
    name: "Luminária de Fibra Natural \"Luar\"",
    category_id: 5,
    status: "active",
    description:
      "Luminária pendente tecida em fibra natural, com luz difusa e aconchegante. Quando acesa, cria sombras orgânicas no ambiente. Combina com salas, quartos e varandas.",
    pricing_mode: 1,
    currency: "BRL",
    price: 219.9,
    stock: 10,
    discount_enabled: true,
    discount_price: 189.9,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Handwoven%20natural%20fiber%20pendant%20lamp%20with%20round%20organic%20shape%20and%20visible%20woven%20texture%2C%20hanging%20against%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20earthy%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p9a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Natural%20fiber%20pendant%20lamp%20glowing%20warmly%20above%20a%20wooden%20dining%20table%20in%20a%20cozy%20Brazilian%20dining%20room%20at%20dusk%2C%20soft%20ambient%20light%2C%20earthy%20natural%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p9b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 5, name: "Iluminação", sort_order: 5 },
  },
  {
    id: 10,
    name: "Abajur de Barro \"Lampião\"",
    category_id: 5,
    status: "active",
    description:
      "Abajur de mesa com base em cerâmica artesanal e cúpula de linho. Luz quente e suave, ideal para cabeceira, aparador ou canto de leitura.",
    pricing_mode: 1,
    currency: "BRL",
    price: 179.9,
    stock: 9,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Table%20lamp%20with%20handmade%20ceramic%20clay%20base%20and%20natural%20linen%20shade%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20warm%20earthy%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p10a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Table%20lamp%20with%20ceramic%20base%20glowing%20warmly%20on%20a%20wooden%20bedside%20table%20with%20a%20book%20and%20small%20vase%2C%20cozy%20Brazilian%20bedroom%2C%20soft%20evening%20light%2C%20earthy%20natural%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p10b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 5, name: "Iluminação", sort_order: 5 },
  },
  {
    id: 11,
    name: "Escultura de Madeira \"Raiz\"",
    category_id: 6,
    status: "active",
    description:
      "Escultura decorativa esculpida em madeira de demolição, com formas orgânicas inspiradas na natureza. Peça única que adiciona presença e textura a estantes e aparadores.",
    pricing_mode: 1,
    currency: "BRL",
    price: 139.9,
    stock: 7,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Hand%20carved%20wooden%20decorative%20sculpture%20with%20smooth%20organic%20curves%20and%20visible%20wood%20grain%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20warm%20brown%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p11a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Wooden%20sculpture%20on%20a%20light%20wood%20shelf%20among%20books%20and%20a%20ceramic%20vase%2C%20soft%20morning%20light%2C%20cozy%20Brazilian%20living%20room%20decor%2C%20natural%20earthy%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p11b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 6, name: "Objetos Decorativos", sort_order: 6 },
  },
  {
    id: 12,
    name: "Espelho com Moldura de Palha \"Janela\"",
    category_id: 6,
    status: "active",
    description:
      "Espelho redondo com moldura trançada em palha natural. Peça leve, com cara de casa de campo, que amplia o ambiente e traz textura para a parede.",
    pricing_mode: 1,
    currency: "BRL",
    price: 259.9,
    stock: 6,
    discount_enabled: false,
    discount_price: null,
    media: [
      {
        url: "https://readdy.ai/api/search-image?query=Round%20mirror%20with%20handwoven%20natural%20straw%20frame%2C%20centered%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20daylight%2C%20simple%20styled%20product%20photography%20for%20a%20Brazilian%20home%20decor%20shop%2C%20earthy%20beige%20tones%2C%20realistic%20detail&width=800&height=800&seq=casaflor-p12a&orientation=squarish",
        type: "image",
      },
      {
        url: "https://readdy.ai/api/search-image?query=Round%20straw%20framed%20mirror%20hanging%20on%20a%20warm%20white%20wall%20above%20a%20wooden%20console%20with%20a%20vase%20and%20candle%2C%20soft%20afternoon%20light%2C%20cozy%20Brazilian%20entryway%2C%20natural%20earthy%20palette%2C%20realistic%20lifestyle%20interior%20photography&width=800&height=800&seq=casaflor-p12b&orientation=squarish",
        type: "image",
      },
    ],
    product_categories: { id: 6, name: "Objetos Decorativos", sort_order: 6 },
  },
];

export const mockVariants = [
  { id: 101, product_id: 1, name: "Tamanho", options: ["P", "M", "G"], sort_order: 1 },
  { id: 102, product_id: 3, name: "Tamanho", options: ["6 peças", "12 peças"], sort_order: 1 },
  { id: 103, product_id: 5, name: "Cor", options: ["Terracota", "Musgo", "Areia", "Petróleo"], sort_order: 1 },
  { id: 104, product_id: 7, name: "Aroma", options: ["Cerrado", "Lavanda", "Eucalipto"], sort_order: 1 },
  { id: 105, product_id: 9, name: "Tamanho", options: ["Pequena", "Média", "Grande"], sort_order: 1 },
];

export const mockSkus = [
  { id: 201, product_id: 1, label: "Vaso P", options: ["P"], price: 129.9, stock: 14, discount_enabled: false, discount_price: null },
  { id: 202, product_id: 1, label: "Vaso M", options: ["M"], price: 149.9, stock: 10, discount_enabled: false, discount_price: null },
  { id: 203, product_id: 1, label: "Vaso G", options: ["G"], price: 179.9, stock: 6, discount_enabled: false, discount_price: null },
  { id: 204, product_id: 3, label: "Mesa Posta 6", options: ["6 peças"], price: 249.9, stock: 8, discount_enabled: false, discount_price: null },
  { id: 205, product_id: 3, label: "Mesa Posta 12", options: ["12 peças"], price: 449.9, stock: 4, discount_enabled: false, discount_price: null },
  { id: 206, product_id: 5, label: "Almofada Terracota", options: ["Terracota"], price: 149.9, stock: 18, discount_enabled: true, discount_price: 119.9 },
  { id: 207, product_id: 5, label: "Almofada Musgo", options: ["Musgo"], price: 149.9, stock: 15, discount_enabled: true, discount_price: 119.9 },
  { id: 208, product_id: 5, label: "Almofada Areia", options: ["Areia"], price: 149.9, stock: 20, discount_enabled: true, discount_price: 119.9 },
  { id: 209, product_id: 5, label: "Almofada Petróleo", options: ["Petróleo"], price: 149.9, stock: 12, discount_enabled: true, discount_price: 119.9 },
  { id: 210, product_id: 7, label: "Vela Cerrado", options: ["Cerrado"], price: 59.9, stock: 40, discount_enabled: false, discount_price: null },
  { id: 211, product_id: 7, label: "Vela Lavanda", options: ["Lavanda"], price: 59.9, stock: 35, discount_enabled: false, discount_price: null },
  { id: 212, product_id: 7, label: "Vela Eucalipto", options: ["Eucalipto"], price: 59.9, stock: 28, discount_enabled: false, discount_price: null },
  { id: 213, product_id: 9, label: "Luminária Pequena", options: ["Pequena"], price: 219.9, stock: 10, discount_enabled: true, discount_price: 189.9 },
  { id: 214, product_id: 9, label: "Luminária Média", options: ["Média"], price: 269.9, stock: 7, discount_enabled: true, discount_price: 229.9 },
  { id: 215, product_id: 9, label: "Luminária Grande", options: ["Grande"], price: 319.9, stock: 5, discount_enabled: true, discount_price: 279.9 },
];